/*
 * @Author: your name
 * @Date: 2021-08-23 14:26:03
 * @LastEditTime: 2021-08-23 15:14:56
 * @LastEditors: Please set LastEditors
 * @Description: resize
 * @FilePath: \contingency-manage\src\directives\resize.js
 */
var ro;

const resize = {
  mounted(el, binding) {
    ro = new ResizeObserver(entries => {
      for (const entry of entries) {
        binding.value(entry.contentRect);
      }
    });
    // 观察一个或多个元素
    ro.observe(el);
  },
  unmounted(el, binding) {
    // 取消和结束目标对象上所有对 Element 观察。
    ro.disconnect(el);
  }
};
export default resize;